export default class MobileMenu {
    constructor($el) {
        this.$el = $el;
        this.$hamburger = this.$el.querySelector('[data-hamburger]');
        this.$menu = this.$el.querySelector('[data-header-menu]');
        this.onResize = this.onResize.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);

        if (!this.$hamburger || !this.$menu) {
            return;
        }

        this.$hamburger.addEventListener('click', this.toggleMenu);
        document.addEventListener('keydown', this.onKeyDown);
        window.addEventListener('resize', this.onResize, {passive: true});
    }

    toggleMenu(e) {
        e.preventDefault();

        const isOpen = this.$hamburger.classList.toggle('hamburger--open');
        this.$menu.classList.toggle('header__menu--open', isOpen);
        this.updateButtonState(isOpen);
    }

    updateButtonState(isOpen) {
        const label = isOpen ?
            this.$hamburger.dataset.labelClose :
            this.$hamburger.dataset.labelOpen;

        this.$hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        this.$menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

        if (label) {
            this.$hamburger.setAttribute('aria-label', label);
        }
    }

    closeMenu() {
        this.$hamburger.classList.remove('hamburger--open');
        this.$menu.classList.remove('header__menu--open');
        this.updateButtonState(false);
    }

    onKeyDown(e) {
        if (e.key === 'Escape' && this.$hamburger.classList.contains('hamburger--open')) {
            this.closeMenu();
            this.$hamburger.focus();
        }
    }

    onResize() {
        if (window.matchMedia('(min-width: 992px)').matches) {
            this.closeMenu();
        }
    }
}
